// Utils
import { getIsSsrMobile } from "src/utils/getIsSsrMobile"

// Layout
import MainLayout from "src/layouts/mainLayout"

// Hooks
import { useIsMobile } from "src/hooks/useIsMobile"

// Components
import DesktopTickets from "src/components/pages/tickets/desktop"
import MobileTickets from "src/components/pages/tickets/mobile"

// ---------------------------------------|| TICKETS - PAGES ||----------------------------------------------

const Tickets = () => {
  const isMobile = useIsMobile()

  return isMobile ? <MobileTickets /> : <DesktopTickets />
}

Tickets.Layout = MainLayout

export default Tickets

export async function getServerSideProps(context = GetServerSidePropsContext) {
  return {
    props: {
      isSsrMobile: getIsSsrMobile(context)
    }
  }
}
